import AttendAgreement36Application from './AttendAgreement36Application'

export default AttendAgreement36Application;